import classNames from "classnames";
import React from "react";

export const TableBody = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
  <tbody
    ref={ref}
    className={classNames("g-table__body", className)}
    {...props}
  />
));
TableBody.displayName = "TableBody";
